import React from "react";

const IsSchoolAdded = () => {
  let CheckSchool = JSON.parse(localStorage.getItem("schoolId"));
  if (CheckSchool) {
    return true;
  } else {
    return false;
  }
};

export default IsSchoolAdded;
